import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { updateCustomer } from '../api/customersApi';

// On success we seed `['customer', id]` from the response body so the
// Details card's "last-saved snapshot" stays authoritative without a second
// GET round-trip. The server also broadcasts UpdateCustomerTable to the
// tenant group — useCustomer's SignalR handler will pick that up too, but
// will skip the invalidation if the card is still dirty.
//
// No success toast — the card's status pill already shows "Saved". Toasting
// every autosave tick would be noise. We do toast on error because the pill
// is small and easy to miss.
export default function useUpdateCustomer() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }) => updateCustomer(id, body),
        onSuccess: (fresh) => {
            queryClient.setQueryData(['customer', fresh.id], fresh);
        },
        onError: (err) => toast.error(err?.message ?? 'Failed to save customer'),
    });
}
